import React from "react";
import { Descriptions, Drawer, Tag } from "antd";
import dayjs from "dayjs";

const formatCurrency = (amount, currency = "USD") => {
  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount)) return "-";

  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: (currency || "USD").toUpperCase(),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericAmount);
  } catch {
    return `${numericAmount.toFixed(2)} ${currency || "USD"}`;
  }
};

const formatDate = (value) => (value ? dayjs(value).format("YYYY-MM-DD hh:mm A") : "-");

export default function CouponUsageChargeDetailsDrawer({ open, usage, onClose }) {
  return (
    <Drawer
      className="coupon-usage-charge-drawer"
      placement="right"
      width={480}
      open={open}
      title="Payment Charge Details"
      onClose={onClose}
      destroyOnHidden
      zIndex={9998}
      styles={{
        header: { padding: "12px 16px" },
        body: { padding: 16 },
      }}
    >
      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label="Charge ID">
          {usage?.chargeId || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Payment Processor ID">
          {usage?.paymentProcessorId || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Payment Status">
          <Tag color={usage?.paymentStatus === "SUCCESS" ? "green" : "default"}>
            {usage?.paymentStatus || "-"}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Charge Code">
          {usage?.chargeCode || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Charge Item ID">
          {usage?.chargeItemId || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Product">
          {usage?.clientApp || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Currency">
          {usage?.currency || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Amount">
          {formatCurrency(usage?.amount, usage?.currency)}
        </Descriptions.Item>
        <Descriptions.Item label="Chargeable Amount">
          {formatCurrency(usage?.chargeableAmount, usage?.currency)}
        </Descriptions.Item>
        <Descriptions.Item label="Receivable Amount">
          {formatCurrency(usage?.receivableAmount, usage?.currency)}
        </Descriptions.Item>
        <Descriptions.Item label="Coupon Discount">
          {formatCurrency(usage?.discountAmount, usage?.currency)}
        </Descriptions.Item>
        <Descriptions.Item label="Payer ID">
          {usage?.payerId || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {formatDate(usage?.chargeCreatedAt)}
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
}
